export default __webpack_public_path__ + "static/media/Ebanking.556fbe84.png";